<template>
    <categories-module-component/>
</template>

<script>
    import CategoriesModuleComponent from "@/components/admin/CategoriesModuleComponent";

    export default {
        name: "CategoriesModule",
        title: "Categorías | Equity Baja",
        components: {CategoriesModuleComponent}
    }
</script>

<style scoped>

</style>